import _getBuiltIn from "../internals/get-built-in";
import _setToStringTag from "../internals/set-to-string-tag";
var getBuiltIn = _getBuiltIn;
var setToStringTag = _setToStringTag;
var DOM_EXCEPTION = "DOMException";

// `DOMException.prototype[@@toStringTag]` property
setToStringTag(getBuiltIn(DOM_EXCEPTION), DOM_EXCEPTION);
export default {};